import React from 'react';
import { useRecoilValue } from 'recoil';
import classNames from 'classnames';
import { Color } from '../../enums/Color.enum';
import { assetPathFnState } from '../../recoil/atoms';
import styles from './ColorSwatch.module.scss';

interface Props {
  color: Color | undefined;
  active: boolean;
  activate: (color: Color | undefined) => void;
  deactivate?: (color: Color | undefined) => void;
  saleMessage?: string;
  showSmall?: boolean;
  hideWhiteBorder?: boolean;
  slim?: boolean;
}

export const ColorSwatch: React.FC<Props> = ({ color, active, activate, deactivate, saleMessage, showSmall = false, hideWhiteBorder, slim }) => {
  const assetPathFn = useRecoilValue(assetPathFnState);
  const colorKey = color ? toColorKey(color) : 'all';
  const isTwoColor = colorKey.match('-and-');

  return (
    <button
      aria-label={color ?? 'color'}
      role="radio"
      aria-checked={active ? 'true' : 'false'}
      className={classNames(styles[`color-swatch-${colorKey}`], styles.hlSwatchCircleImage, {
        [styles.selected]: active,
        [styles.twoColor]: isTwoColor,
        [styles.small]: showSmall,
        [styles.noWhiteBorder]: hideWhiteBorder,
        [styles.slim]: slim,
      })}
      onClick={() => {
        !active && activate(color);
        active && deactivate && deactivate(color);
      }}
    >
      {saleMessage && <span className={classNames(styles.sale, { [styles.light]: saleMessage === '20%' })}>{saleMessage}</span>}
      {colorKey === 'all' && (
        <div style={{ backgroundSize: 'contain', width: '28px', height: '28px', backgroundImage: `url(${assetPathFn('color-wheel-palette_56x56.png')})` }} />
      )}
      {colorKey !== 'all' && (
        <React.Fragment>
          <span className={styles.hlSwatchTop} />
          <span className={styles.hlSwatchBottom} />
        </React.Fragment>
      )}
      <span className={styles.hlCheck} />
    </button>
  );
};
const toColorKey = (color: Color) => color.toLowerCase().replace(/\s/g, '-');

export default ColorSwatch;
